export default __webpack_public_path__ + "static/media/image04.e6a8a388.jpg";